import { useApiQuery } from '@vrplatform/data';
import {
  type OwnerStatementSummariesDetailTransactionLookup,
  type OwnerStatementSummariesDetailTransactionsById,
  mapOwnerStatementSummariesDetailTransactionsById,
} from './OwnerStatementSummariesDetail.utils';

export const STORYBOOK_OWNER_STATEMENT_SUMMARIES_DETAIL_TRANSACTIONS_QUERY_KEY =
  'owner-statement-summaries-detail-transactions';

export const useOwnerStatementSummariesDetailTransactionsQuery = ({
  lookup,
}: {
  lookup: OwnerStatementSummariesDetailTransactionLookup;
}) => {
  const hasLookup =
    lookup.ids.length > 0 ||
    lookup.shortRefs.length > 0 ||
    lookup.uniqueRefs.length > 0;

  return useApiQuery(
    async ($api, signal, args) => {
      const transactions = await Promise.all([
        args.lookup.ids.length
          ? $api
              .GET('/transactions', {
                params: {
                  query: {
                    ids: args.lookup.ids.join(','),
                    includeLines: true,
                    limit: args.lookup.ids.length,
                  },
                },
                signal,
              })
              .then((res) => {
                if (res.error) throw res.error;
                return res.data.data;
              })
          : [],
        args.lookup.shortRefs.length
          ? $api
              .GET('/transactions', {
                params: {
                  query: {
                    shortRefs: args.lookup.shortRefs.join(','),
                    includeLines: true,
                    limit: args.lookup.shortRefs.length,
                  },
                },
                signal,
              })
              .then((res) => {
                if (res.error) throw res.error;
                return res.data.data;
              })
          : [],
        args.lookup.uniqueRefs.length
          ? $api
              .GET('/transactions', {
                params: {
                  query: {
                    uniqueRefs: args.lookup.uniqueRefs.join(','),
                    includeLines: true,
                    limit: args.lookup.uniqueRefs.length,
                  },
                },
                signal,
              })
              .then((res) => {
                if (res.error) throw res.error;
                return res.data.data;
              })
          : [],
      ]).then((results) => results.flat());

      return mapOwnerStatementSummariesDetailTransactionsById({
        transactions,
      }) satisfies OwnerStatementSummariesDetailTransactionsById;
    },
    {
      skip: !hasLookup,
      variables: {
        lookup,
      },
      storybookQueryKey:
        STORYBOOK_OWNER_STATEMENT_SUMMARIES_DETAIL_TRANSACTIONS_QUERY_KEY,
      queryGroup: 'owner-statements',
      uniqueQueryKey: 'owner-statement-summaries-detail-transactions',
      queryKeys: ['transactions'],
      keepPreviousData: false,
    }
  );
};
